import styled from 'styled-components';

export const Wrapper = styled.section`
  background-color: #fff;
  margin: 15px 12px;
  @media(min-width: 600px) {
    margin: 15px 22px;
  }
`;